export default __webpack_public_path__ + "static/media/bevezeto.676bac75.png";